/**
 * Banana Santana Shopify Theme JavaScript
 */

(function() {
  'use strict';

  // Smooth scroll for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId && targetId !== '#') {
          const target = document.querySelector(targetId);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  }
  
  // Header scroll effects
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    let lastScrollTop = 0;
    
    if (header) {
      window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // Add/remove scrolled class
        if (scrollTop > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
        
        // Hide/show header on scroll
        if (scrollTop > lastScrollTop && scrollTop > 100) {
          header.classList.add('header-hidden');
        } else {
          header.classList.remove('header-hidden');
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }, false);
    }
  }

  // Theme initialization
  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initCartDrawer();
    initProductCarousel();
    initAnimations();
    initSearch();
    initProductForm();
    initNewsletterForm();
    initCartPage();
    initSmoothScroll();
    initHeaderScroll();
  });

  // Mobile Menu with smooth animations
  function initMobileMenu() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const menu = document.querySelector('.mobile-menu');
    
    if (toggle && menu) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = menu.classList.contains('active');
        
        if (isOpen) {
          // Close menu
          menu.classList.remove('active');
          document.body.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          // Open menu
          menu.classList.add('active');
          document.body.classList.add('menu-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      // Close menu on outside click
      document.addEventListener('click', function(e) {
        if (!menu.contains(e.target) && !toggle.contains(e.target)) {
          menu.classList.remove('active');
          document.body.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menu.classList.contains('active')) {
          menu.classList.remove('active');
          document.body.classList.remove('menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  // Cart Drawer
  function initCartDrawer() {
    const cartToggles = document.querySelectorAll('.cart-toggle');
    const cartDrawer = document.querySelector('.cart-drawer');
    const cartClose = document.querySelector('.cart-drawer-close');
    
    if (cartToggles.length && cartDrawer) {
      cartToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          openCartDrawer();
        });
      });

      if (cartClose) {
        cartClose.addEventListener('click', closeCartDrawer);
      }

      // Close on overlay click
      const overlay = document.querySelector('.cart-drawer-overlay');
      if (overlay) {
        overlay.addEventListener('click', closeCartDrawer);
      }
    }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      document.body.classList.add('cart-open');
    }
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.classList.remove('cart-open');
    }
  }

  // Product Carousel
  function initProductCarousel() {
    const carousels = document.querySelectorAll('[data-carousel]');
    
    carousels.forEach(function(carousel) {
      const track = carousel.querySelector('.carousel-track');
      const items = carousel.querySelectorAll('.carousel-item');
      const prevBtn = carousel.querySelector('.carousel-prev');
      const nextBtn = carousel.querySelector('.carousel-next');
      const dotsContainer = carousel.querySelector('.carousel-dots');
      
      if (!track || !items.length) return;
      
      let currentIndex = 0;
      let itemsPerView = getItemsPerView();
      let maxIndex = Math.max(0, items.length - itemsPerView);
      
      // Create dots
      function createDots() {
        if (!dotsContainer) return;
        
        // Clear existing dots
        dotsContainer.innerHTML = '';
        
        const numDots = Math.ceil(items.length / itemsPerView);
        for (let i = 0; i < numDots; i++) {
          const dot = document.createElement('button');
          dot.classList.add('carousel-dot');
          if (i === Math.floor(currentIndex / itemsPerView)) {
            dot.classList.add('active');
          }
          dot.addEventListener('click', function() {
            goToSlide(i * itemsPerView);
          });
          dotsContainer.appendChild(dot);
        }
      }
      
      createDots();
      
      // Navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          const step = itemsPerView === 1 ? 1 : itemsPerView;
          goToSlide(currentIndex - step);
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          const step = itemsPerView === 1 ? 1 : itemsPerView;
          goToSlide(currentIndex + step);
        });
      }
      
      // Touch support
      let touchStartX = 0;
      let touchEndX = 0;
      
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      track.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;
        
        if (Math.abs(diff) > swipeThreshold) {
          // On mobile (single item), swipe by 1. Otherwise by itemsPerView
          const step = itemsPerView === 1 ? 1 : itemsPerView;
          
          if (diff > 0) {
            // Swipe left - next
            goToSlide(currentIndex + step);
          } else {
            // Swipe right - previous
            goToSlide(currentIndex - step);
          }
        }
      }
      
      function goToSlide(index) {
        currentIndex = Math.max(0, Math.min(index, maxIndex));
        
        // Calculate offset based on viewport
        let offset;
        if (itemsPerView === 1) {
          // Mobile: each item is 100% width
          offset = -(currentIndex * 100);
        } else {
          // Desktop/tablet: calculate based on items per view
          offset = -(currentIndex * (100 / itemsPerView));
        }
        
        track.style.transform = `translateX(${offset}%)`;
        
        // Update dots
        updateDots();
        
        // Update button states
        updateButtonStates();
      }
      
      function updateDots() {
        if (!dotsContainer) return;
        
        const dots = dotsContainer.querySelectorAll('.carousel-dot');
        const activeDotIndex = Math.floor(currentIndex / itemsPerView);
        
        dots.forEach(function(dot, i) {
          dot.classList.toggle('active', i === activeDotIndex);
        });
      }
      
      function updateButtonStates() {
        if (prevBtn) {
          prevBtn.disabled = currentIndex === 0;
          prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
        }
        if (nextBtn) {
          nextBtn.disabled = currentIndex >= maxIndex;
          nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
        }
      }
      
      function getItemsPerView() {
        const width = window.innerWidth;
        if (width >= 1024) return 4;
        if (width >= 768) return 3;
        if (width >= 480) return 2;
        return 1;
      }
      
      // Resize handler
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          const newItemsPerView = getItemsPerView();
          if (newItemsPerView !== itemsPerView) {
            itemsPerView = newItemsPerView;
            maxIndex = Math.max(0, items.length - itemsPerView);
            
            // Reset to valid position if current position is invalid
            if (currentIndex > maxIndex) {
              currentIndex = 0;
            }
            
            // Recreate dots for new layout
            createDots();
            
            // Update position
            goToSlide(currentIndex);
          }
        }, 250);
      });
      
      // Initial button state
      updateButtonStates();
    });
  }

  // Scroll Animations
  function initAnimations() {
    if (!window.theme.settings.animationsEnabled) return;
    
    const animatedElements = document.querySelectorAll('[class*="scroll-"]');
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    animatedElements.forEach(function(element) {
      observer.observe(element);
    });
  }

  // Search
  function initSearch() {
    const searchToggle = document.querySelector('.search-toggle');
    const searchModal = document.querySelector('.search-modal');
    const searchClose = document.querySelector('.search-close');
    const searchInput = document.querySelector('.search-input');
    
    if (searchToggle && searchModal) {
      searchToggle.addEventListener('click', function() {
        searchModal.classList.add('active');
        document.body.classList.add('search-open');
        if (searchInput) searchInput.focus();
      });
      
      if (searchClose) {
        searchClose.addEventListener('click', function() {
          searchModal.classList.remove('active');
          document.body.classList.remove('search-open');
        });
      }
      
      // Close on escape
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchModal.classList.contains('active')) {
          searchModal.classList.remove('active');
          document.body.classList.remove('search-open');
        }
      });
    }
    
    // Predictive search
    if (searchInput && window.theme.settings.predictiveSearchEnabled) {
      let searchTimeout;
      
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        const query = this.value;
        
        if (query.length < 2) {
          clearSearchResults();
          return;
        }
        
        searchTimeout = setTimeout(function() {
          performSearch(query);
        }, 300);
      });
    }
  }

  function performSearch(query) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(response => response.json())
      .then(data => {
        displaySearchResults(data.resources.results.products);
      })
      .catch(error => console.error('Search error:', error));
  }

  function displaySearchResults(products) {
    const resultsContainer = document.querySelector('.search-results');
    if (!resultsContainer) return;
    
    if (!products || products.length === 0) {
      resultsContainer.innerHTML = '<p class="no-results">No results found</p>';
      return;
    }
    
    const html = products.map(product => `
      <a href="${product.url}" class="search-result-item">
        <img src="${product.featured_image}" alt="${product.title}" />
        <div class="search-result-info">
          <h4>${product.title}</h4>
          <p class="price">${formatMoney(product.price)}</p>
        </div>
      </a>
    `).join('');
    
    resultsContainer.innerHTML = html;
  }

  function clearSearchResults() {
    const resultsContainer = document.querySelector('.search-results');
    if (resultsContainer) {
      resultsContainer.innerHTML = '';
    }
  }

  // Product Form
  function initProductForm() {
    const forms = document.querySelectorAll('[data-product-form]');
    
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        const data = {
          items: [{
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity') || 1)
          }]
        };
        
        addToCart(data);
      });
      
      // Variant selection
      const variantSelects = form.querySelectorAll('[data-variant-select]');
      variantSelects.forEach(function(select) {
        select.addEventListener('change', function() {
          const selectedOption = select.options[select.selectedIndex];
          updatePrice(selectedOption.dataset.price);
          updateAvailability(selectedOption.dataset.available === 'true');
        });
      });
    });
  }

  function addToCart(data) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      updateCartDrawer();
      showNotification('Product added to cart!');
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      showNotification('Error adding to cart', 'error');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const countElements = document.querySelectorAll('[data-cart-count]');
        countElements.forEach(function(element) {
          element.textContent = data.item_count;
        });
        
        // Update cart drawer header count
        const drawerTitle = document.querySelector('.cart-drawer-header h2');
        if (drawerTitle) {
          drawerTitle.textContent = `Cart (${data.item_count})`;
        }
      });
  }
  
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateCartCount();
        refreshCartDrawerContent(cart);
        openCartDrawer();
      })
      .catch(error => console.error('Error updating cart drawer:', error));
  }
  
  function refreshCartDrawerContent(cart) {
    const cartContent = document.querySelector('.cart-drawer-content');
    if (!cartContent) return;
    
    if (cart.item_count === 0) {
      cartContent.innerHTML = `
        <div class="cart-drawer-empty">
          <p>Your cart is empty</p>
          <a href="/collections/all" class="btn-primary">Continue Shopping</a>
        </div>
      `;
    } else {
      let itemsHTML = '<div class="cart-drawer-items">';
      
      cart.items.forEach(function(item, index) {
        itemsHTML += `
          <div class="cart-drawer-item">
            <img src="${item.image}" alt="${item.title}">
            <div class="cart-drawer-item-details">
              <h4>${item.product_title}</h4>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="variant">${item.variant_title}</p>` : ''}
              <div class="cart-drawer-item-price">
                <span>${formatMoney(item.price)}</span>
                <span class="quantity">x ${item.quantity}</span>
              </div>
            </div>
            <button class="cart-drawer-remove" onclick="removeFromCart(${index + 1})">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M12 4L8 8L4 12M4 4L8 8L12 12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        `;
      });
      
      itemsHTML += '</div>';
      
      itemsHTML += `
        <div class="cart-drawer-footer">
          <div class="cart-drawer-subtotal">
            <span>Subtotal</span>
            <span class="price">${formatMoney(cart.total_price)}</span>
          </div>
          <a href="/cart" class="btn-secondary">View Cart</a>
          <form action="/cart" method="post">
            <button type="submit" name="checkout" class="btn-primary">
              Checkout
            </button>
          </form>
        </div>
      `;
      
      cartContent.innerHTML = itemsHTML;
    }
  }
  
  function removeFromCart(line) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      refreshCartDrawerContent(cart);
      updateCartCount();
    })
    .catch(error => console.error('Error removing item:', error));
  }

  function updatePrice(price) {
    const priceElement = document.querySelector('[data-product-price]');
    if (priceElement) {
      priceElement.textContent = formatMoney(price);
    }
  }

  function updateAvailability(available) {
    const addButton = document.querySelector('[data-add-to-cart]');
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
    }
  }

  // Newsletter Form
  function initNewsletterForm() {
    const forms = document.querySelectorAll('.newsletter-form');
    
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const email = form.querySelector('input[type="email"]').value;
        
        // Here you would typically send to your newsletter service
        // For now, we'll just show a success message
        showNotification('Thanks for subscribing!', 'success');
        form.reset();
      });
    });
  }

  // Cart Page Functionality
  function initCartPage() {
    // Only run on cart page
    if (!document.querySelector('.main-cart')) return;
    
    // Handle quantity selectors
    const quantitySelectors = document.querySelectorAll('.cart-item-quantity .quantity-selector');
    
    quantitySelectors.forEach(function(selector) {
      const minusBtn = selector.querySelector('.quantity-minus');
      const plusBtn = selector.querySelector('.quantity-plus');
      const input = selector.querySelector('input[type="number"]');
      
      if (!minusBtn || !plusBtn || !input) return;
      
      const lineItem = minusBtn.dataset.line;
      
      // Minus button
      minusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 0) {
          const newValue = currentValue - 1;
          input.value = newValue;
          updateCartQuantity(lineItem, newValue, selector);
        }
      });
      
      // Plus button
      plusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value) || 1;
        const newValue = currentValue + 1;
        input.value = newValue;
        updateCartQuantity(lineItem, newValue, selector);
      });
      
      // Direct input change
      let inputTimeout;
      input.addEventListener('input', function() {
        clearTimeout(inputTimeout);
        inputTimeout = setTimeout(function() {
          const newValue = parseInt(input.value) || 0;
          updateCartQuantity(lineItem, newValue, selector);
        }, 750);
      });
    });
    
    // Handle remove buttons
    const removeButtons = document.querySelectorAll('.cart-item-remove a');
    removeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const href = this.href;
        const row = this.closest('tr');
        
        // Add loading state
        row.style.opacity = '0.5';
        
        // Extract line number from URL
        const match = href.match(/line=(\d+)/);
        if (match) {
          const line = match[1];
          updateCartQuantity(line, 0, null, row);
        }
      });
    });
  }
  
  function updateCartQuantity(line, quantity, selector, row) {
    // Show loading state
    if (selector) {
      selector.style.opacity = '0.5';
      const buttons = selector.querySelectorAll('button');
      buttons.forEach(btn => btn.disabled = true);
    }
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Update cart count
      updateCartCount();
      
      if (quantity === 0 && row) {
        // Remove the row with animation
        row.style.transition = 'opacity 0.3s, transform 0.3s';
        row.style.opacity = '0';
        row.style.transform = 'translateX(-20px)';
        setTimeout(function() {
          row.remove();
          
          // Check if cart is empty
          const remainingItems = document.querySelectorAll('.cart-item');
          if (remainingItems.length === 0) {
            location.reload(); // Reload to show empty cart message
          }
        }, 300);
      } else if (selector) {
        // Update the line total
        const lineIndex = parseInt(line) - 1;
        const item = cart.items[lineIndex];
        
        if (item) {
          const row = selector.closest('tr');
          const totalCell = row.querySelector('.cart-item-total');
          if (totalCell) {
            totalCell.textContent = formatMoney(item.line_price);
          }
        }
        
        // Restore selector state
        selector.style.opacity = '1';
        const buttons = selector.querySelectorAll('button');
        buttons.forEach(btn => btn.disabled = false);
        
        // Update minus button state
        const minusBtn = selector.querySelector('.quantity-minus');
        const input = selector.querySelector('input[type="number"]');
        if (minusBtn && input) {
          minusBtn.disabled = parseInt(input.value) <= 0;
          minusBtn.style.opacity = parseInt(input.value) <= 0 ? '0.5' : '1';
        }
      }
      
      // Update cart totals
      updateCartTotals(cart);
      
      // Show notification
      if (quantity === 0) {
        showNotification('Item removed from cart', 'success');
      } else {
        showNotification('Cart updated', 'success');
      }
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      showNotification('Error updating cart', 'error');
      
      // Restore state on error
      if (selector) {
        selector.style.opacity = '1';
        const buttons = selector.querySelectorAll('button');
        buttons.forEach(btn => btn.disabled = false);
      }
      if (row) {
        row.style.opacity = '1';
      }
    });
  }
  
  function updateCartTotals(cart) {
    // Update subtotal
    const subtotalElement = document.querySelector('.cart-subtotal .price');
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(cart.total_price);
    }
    
    // Update item count in heading if present
    const cartTitle = document.querySelector('.page-title');
    if (cartTitle && cart.item_count > 0) {
      cartTitle.textContent = `Cart (${cart.item_count})`;
    }
  }

  // Utility Functions
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(function() {
      notification.classList.add('show');
    }, 10);
    
    setTimeout(function() {
      notification.classList.remove('show');
      setTimeout(function() {
        notification.remove();
      }, 300);
    }, 3000);
  }

  // Quick Shop
  window.quickShop = function(productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        showQuickShopModal(product);
      })
      .catch(error => console.error('Quick shop error:', error));
  };

  function showQuickShopModal(product) {
    // Create and show modal with product details
    // This would be implemented based on your modal design
    console.log('Quick shop:', product);
  }

  // Expose functions to global scope if needed
  window.theme = window.theme || {};
  window.theme.cart = {
    open: openCartDrawer,
    close: closeCartDrawer,
    update: updateCartDrawer,
    updateCount: updateCartCount,
    remove: removeFromCart
  };
  
  // Expose removeFromCart to global scope for onclick handlers
  window.removeFromCart = removeFromCart;

})();